import React from "react";

import * as S from "./TableDragDivider.style";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isDraggingEndPosition: boolean;
}

const TableDragDivider = ({ isDraggingEndPosition, ...rest }: Props) => {
  return (
    <S.TableDividerBar
      isDraggingEndPosition={isDraggingEndPosition}
      {...rest}
    />
  );
};

export default TableDragDivider;
